import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke901aRequest, Sgke901aResponse, Sgke901aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';
/**
 *SGKE901A_お客さま帳票管理登録（請求お客さま番号）API実施処理
 * @export
 * @class UsedSgke901aService
 */
@Injectable({
  providedIn: 'root'
})

export class UsedSgke901aService {
  /**
   * コンストラクタ
   * @param {Sgke901aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke901aService
   */
  constructor(public service: Sgke901aService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig) { }
  /**
   *　SGKE901A_お客さま帳票管理登録（請求お客さま番号）API呼び出し
   * @param request
   * @returns
   */
  public doSgke901a(request: Sgke901aRequest): Observable<Sgke901aResponse> {

    return this.service.ke10WSGKE901APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE901A');
          return throwError(err.message);
        })
      );
  }
}
